import React, { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { PageLayout } from "../../ui-components/PageLayout";

/**
 * Admin destinations. Email templates keeps its original /settings URL so existing links and
 * bookmarks stay valid; the tab only selects it.
 */
const ADMIN_TABS = [
  { label: "Affiliates", path: "/admin/affiliates" },
  { label: "Email templates", path: "/settings/email-templates" },
  { label: "PropMix", path: "/admin/propmix" },
  { label: "Impersonation", path: "/admin/impersonation" },
];

/** Shared frame for every admin screen: one page, one set of tabs. */
export function AdminPage({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const current = ADMIN_TABS.findIndex((tab) => pathname.startsWith(tab.path));

  return (
    <PageLayout>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
          Admin
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={current === -1 ? false : current}
            onChange={(_event, index) => navigate(ADMIN_TABS[index].path)}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Admin sections"
          >
            {ADMIN_TABS.map((tab) => (
              <Tab key={tab.path} label={tab.label} />
            ))}
          </Tabs>
        </Box>

        {children}
      </Box>
    </PageLayout>
  );
}
